import React from "react";

type Props = {
  color: string;
  children?: React.ReactNode;
  bannerRef?: React.RefObject<HTMLDivElement>;
};

const Banner = React.forwardRef<HTMLDivElement, Props>(
  ({ color, children }, ref) => {
    return (
      <div className={`banner banner--${color} page-content`} ref={ref}>
        {children}
      </div>
    );
  }
);

export default Banner;
